import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const ContainerEnvironment = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${colors.red};
  color: white;
  font-size: 26px;
  a:link {
    color: black;
  }
  a:visited {
    color: white;
  }
  a:hover {
    color: black;
  }
  a:active {
    color: black;
  }
`
export const Text = styled.span`
  @media (min-width: 320px) {
    font-size: 8px;
  }

  @media (min-width: 480px) {
    font-size: 12px;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    font-size: 22px;
  }

  @media (min-width: 1440px) {
    font-size: 26px;
  }
`
